import { render, staticRenderFns } from "./PCPSectionModal.vue?vue&type=template&id=55f0bba5&scoped=true"
import script from "./PCPSectionModal.vue?vue&type=script&lang=js"
export * from "./PCPSectionModal.vue?vue&type=script&lang=js"
import style0 from "./PCPSectionModal.vue?vue&type=style&index=0&id=55f0bba5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f0bba5",
  null
  
)

export default component.exports